export const getQueue = (state) => state.app.queue;
export const getIsMobile = (state) => state.app.isMobile;
